import React from 'react';
import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import Link from 'next/link';
export const RoomsSliderCentered = props => {
  const { imageSource, title, titleOne } = props; //btnText, href, bg,

  return (
    <>
      <div>
        {title ? (
          <HeadingSection title={title} bgcolor="white" />
        ) : (
          <div className="container pt-4 lg:px-2 md:px-1 px-2 pb-3 xl:px-2 2xl:px-3">
            <div className="   lg:px-0 xl:px-0 2xl:px-2">
              <div className="col-12 px-0 md:px-3 lg:px-1 xl:px-1 2xl:px-0">
                <p
                  className="text-uppercase fontWeight fs-4 size"
                  style={{ fontFamily: 'Fjalla One', color: '#000000' }}>
                  {titleOne}
                </p>
                <hr className="mb-4 mt-3 text-black"></hr>
              </div>
            </div>
          </div>
        )}
        <div className="w-full pb-3">
          <div className="container mx-auto px-6">
            <div className=" 2xl-px-1">
              <div className="container mx-auto 2xl-px-3 text-center carousel-wrapper">
                <Carousel
                  className="Center-Slider bg-black sm:bg-white"
                  autoPlay
                  centerMode={true}
                  centerSlidePercentage={60}
                  showArrows={true}
                  showIndicators={false}
                  thumbWidth={100}>
                  {imageSource.map((Item, index) => (
                    <div key={index}>
                      <img loading="lazy" src={Item.src} />
                    </div>
                  ))}
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RoomsSliderCentered;
